Object.assign(Date, {
  timeUntil(value) {
    const difference = new Date(value) - new Date();

    if (difference <= 0) {
      return "0 segundo";
    }

    const units = [
      { label: "ano", ms: 365 * 24 * 60 * 60 * 1000 },
      { label: "mês", ms: 30 * 24 * 60 * 60 * 1000 }, // Aproximação
      { label: "dia", ms: 24 * 60 * 60 * 1000 },
      { label: "hora", ms: 60 * 60 * 1000 },
      { label: "minuto", ms: 60 * 1000 },
      { label: "segundo", ms: 1000 },
    ];

    for (const { label, ms } of units) {
      const time = Math.floor(difference / ms);
      if (time >= 1) {
        return `${time} ${label}${
          time > 1 ? (label === "mês" ? "es" : "s") : ""
        }`;
      }
    }

    return "0 segundo";
  },
});
